import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsSmRalEncroachmentList from "../created-list-inner-pages/tms-sm-ral-encroachment-list";
import TmsEncroachment from "../creation-inner-pages/tms-encroachment";
const LandEncroachmentIndex = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Encroachment Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsSmRalEncroachmentList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"Encroachment Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsEncroachment setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default LandEncroachmentIndex;
